import React from 'react';
import App from './containers/app';
import reportWebVitals from './reportWebVitals';
import ReactDOMClient from 'react-dom/client';

(() => {
  ReactDOMClient.createRoot(document.getElementById('root')).render(<App />);
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
